export const RDX_ESG_QUESTIONNAIRE_DATA = 'rdx/environmental/social/governance/questionnaire/data';
export const RDX_ESG_QUESTIONNAIRE_DATA_DONE = 'rdx/environmental/social/governance/questionnaire/data/done';
export const RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT = 'rdx/environmental/social/governance/questionnaire/data/submit';
export const RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT_AND_PRINT = 'rdx/environmental/social/governance/questionnaire/data/submit/print';
export const RDX_ESG_QUESTIONNAIRE_RESPONSES = 'rdx/environmental/social/governance/questionnaire/responses';
export const RDX_ESG_QUESTIONNAIRE_RESPONSES_HISTORY = 'rdx/environmental/social/governance/questionnaire/responses/history';
export const RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE = 'rdx/environmental/social/governance/questionnaire/responses/done';
export const RDX_ESG_QUESTIONNAIRE_VALIDATE = 'rdx/environmental/social/governance/questionnaire/validate';
export const RDX_ESG_QUESTIONNAIRE_UPDATE_VALIDATE = 'rdx/environmental/social/governance/questionnaire/validate/update';
export const RDX_ESG_QUESTIONNAIRE_UPDATE_RESPONSE = 'rdx/environmental/social/governance/questionnaire/update/response';
export const RDX_ESG_REPORT_GENERATE = 'rdx/environmental/social/governance/report/generate';
export const RDX_ESG_RETRIEVE_REPORT_DOCUMENT_ID = 'rdx/environmental/social/governance/retrieve/report/document/id';
export const RDX_ESG_UPDATE_REPORT_DOCUMENT_ID_STATUS = 'rdx/environmental/social/governance/update/report/document/id/status';
export const RDX_ESG_DOWNLOAD_ESG_REPORT = 'rdx/environmental/social/governance/download/esg/report';
export const RDX_ESG_QUESTIONNAIRE_START = 'rdx/environmental/social/governance/esg/start';

export const initQuestionnaire = () => ({
	type: RDX_ESG_QUESTIONNAIRE_DATA
});

export const initQuestionnaireDone = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_DATA_DONE,
	data
});

export const esgStart = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_START,
	data
});

export const submitData = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT,
	data
});

export const submitDataAndPrint = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT_AND_PRINT,
	data
});


export const retrieveQuestionnaireResponses = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_RESPONSES,
	data
});

export const retrieveHistoryQuestionnaireResponses = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_RESPONSES_HISTORY,
	data
});

export const retrieveQuestionnaireResponsesDone = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE,
	data
});

export const validateInput = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_VALIDATE,
	data
});

export const updateValidateInput = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_UPDATE_VALIDATE,
	data
});

export const updateQuestionResponse = (data) => ({
	type: RDX_ESG_QUESTIONNAIRE_UPDATE_RESPONSE,
	data
});

export const reportGenerate = (data) => (
	{
		type: RDX_ESG_REPORT_GENERATE,
		data
	}
);

export const retrieveReportDocumnetId = (data) => (
	{
		type: RDX_ESG_RETRIEVE_REPORT_DOCUMENT_ID,
		data
	}
);

export const updateReportDocumnetIdStatus = (data) => ({
	type: RDX_ESG_UPDATE_REPORT_DOCUMENT_ID_STATUS,
	data
});

export const downloadEsgReport = (data) => ({
	type: RDX_ESG_DOWNLOAD_ESG_REPORT,
	data
});
